<!-- src/views/pages/administration/settings/others-settings/backup-settings.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header px-0 mx-3">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Backup</h4>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="d-flex align-items-center justify-content-between">
                <nav
                  class="nav nav-pills flex-column flex-sm-row"
                  role="tablist"
                >
                  <!-- <a
                    class="flex-sm-fill text-sm-center nav-link tab-dark"
                    :class="{ active: activeTab === 'system' }"
                    data-bs-toggle="tab"
                    role="tab"
                    aria-current="page"
                    href="#system-backup"
                    aria-selected="activeTab === 'system'"
                    @click.prevent="activeTab = 'system'"
                  >
                    System Backup
                  </a> -->
                  <a
                    class="flex-sm-fill text-sm-center nav-link tab-dark"
                    
                    data-bs-toggle="tab"
                    role="tab"
                    aria-current="page"
                    href="#database-backup"
                    aria-selected="activeTab === 'database'"
                    @click.prevent="activeTab = 'database'"
                  >
                    Database Backup
                  </a>
                </nav>
                <a
                  href="javascript:void(0);"
                  class="btn btn-sm btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#generate_backup"
                >
                  Generate Backup
                </a>
              </div>
              <p v-if="loading" class="mt-2 mb-2 text-muted">
                Loading backups...
              </p>
              <div class="tab-content mt-3">
                <!-- System -->
                <div
                  class="tab-pane text-muted"
                  :class="{ 'show active': activeTab === 'system' }"
                  id="system-backup"
                  role="tabpanel"
                >
                  <div class="card mb-3">
                    <div
                      class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                    >
                      <h5>System Backup List</h5>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th class="no-sort">
                                <div class="form-check form-check-md">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="select-all"
                                    :checked="isAllSystemSelected"
                                    @change="toggleSelectAllSystem"
                                  />
                                </div>
                              </th>
                              <th>File Name</th>
                              <th>Date</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!loading && !systemBackups.length">
                              <td colspan="4" class="text-center py-3">
                                No system backups found.
                              </td>
                            </tr>
                            <tr v-for="item in systemBackups" :key="item.id">
                              <td>
                                <div class="form-check form-check-md">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="item.id"
                                    v-model="selectedSystemIds"
                                  />
                                </div>
                              </td>
                              <td>
                                <p class="fs-14 fw-medium text-dark">
                                  {{ item.file_name }}
                                </p>
                              </td>
                              <td>{{ formatDate(item.created_at) }}</td>
                              <td>
                                <div class="action-icon d-inline-flex">
                                  <a
                                    href="javascript:void(0);"
                                    class="me-2"
                                    @click="download(item)"
                                  >
                                    <i class="ti ti-download"></i>
                                  </a>
                                  <a
                                    href="javascript:void(0);"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete_modal"
                                    @click="prepareDelete(item, 'system')"
                                  >
                                    <i class="ti ti-trash"></i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-end align-items-center border-top px-3 py-2"
                      v-if="selectedSystemIds.length"
                    >
                      <button
                        class="btn btn-outline-danger btn-sm"
                        type="button"
                        @click="bulkDelete('system')"
                      >
                        <i class="ti ti-trash me-1"></i> Delete Selected
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Database -->
                <div
                  class="tab-pane text-muted"
                  :class="{ 'show active': activeTab === 'database' }"
                  id="database-backup"
                  role="tabpanel"
                >
                  <div class="card mb-3">
                    <div
                      class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                    >
                      <h5>Datebase Backup List</h5>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th class="no-sort">
                                <div class="form-check form-check-md">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="select-all2"
                                    :checked="isAllDbSelected"
                                    @change="toggleSelectAllDb"
                                  />
                                </div>
                              </th>
                              <th>File Name</th>
                              <th>Date</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!loading && !databaseBackups.length">
                              <td colspan="4" class="text-center py-3">
                                No database backups found.
                              </td>
                            </tr>
                            <tr v-for="item in databaseBackups" :key="item.id">
                              <td>
                                <div class="form-check form-check-md">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="item.id"
                                    v-model="selectedDbIds"
                                  />
                                </div>
                              </td>
                              <td>
                                <p class="fs-14 fw-medium text-dark">
                                  {{ item.file_name }}
                                </p>
                              </td>
                              <td>{{ formatDate(item.created_at) }}</td>
                              <td>
                                <div class="action-icon d-inline-flex">
                                  <a
                                    href="javascript:void(0);"
                                    class="me-2"
                                    @click="download(item)"
                                  >
                                    <i class="ti ti-download"></i>
                                  </a>
                                  <a
                                    href="javascript:void(0);"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete_modal"
                                    @click="prepareDelete(item, 'database')"
                                  >
                                    <i class="ti ti-trash"></i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-end align-items-center border-top px-3 py-2"
                      v-if="selectedDbIds.length"
                    >
                      <button
                        class="btn btn-outline-danger btn-sm"
                        type="button"
                        @click="bulkDelete('database')"
                      >
                        <i class="ti ti-trash me-1"></i> Delete Selected
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Pass activeTab down so modal knows which type to generate -->
  <backup-modal :active-tab="activeTab" />
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useBackupStore } from "@/stores/settings/backup.store";
import BackupService from "@/services/settings/backup.service";
import { toast } from "@/utils/toast";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const backupStore = useBackupStore();

const loading = computed(() => backupStore.loading);
const systemBackups = computed(() => backupStore.systemBackups);
const databaseBackups = computed(() => backupStore.databaseBackups);

const activeTab = ref("system");
const selectedSystemIds = ref([]);
const selectedDbIds = ref([]);

const isAllSystemSelected = computed(
  () =>
    systemBackups.value.length > 0 &&
    selectedSystemIds.value.length === systemBackups.value.length
);
const isAllDbSelected = computed(
  () =>
    databaseBackups.value.length > 0 &&
    selectedDbIds.value.length === databaseBackups.value.length
);

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function toggleSelectAllSystem(e) {
  if (e.target.checked) {
    selectedSystemIds.value = systemBackups.value.map((b) => b.id);
  } else {
    selectedSystemIds.value = [];
  }
}

function toggleSelectAllDb(e) {
  if (e.target.checked) {
    selectedDbIds.value = databaseBackups.value.map((b) => b.id);
  } else {
    selectedDbIds.value = [];
  }
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString();
}

async function download(item) {
  try {
    const res = await BackupService.download(item.id);
    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = item.file_name || "backup.dat";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    toast(
      e?.response?.data?.message || "Failed to download backup file",
      "error"
    );
  }
}

async function bulkDelete(type) {
  if (type === "system" && selectedSystemIds.value.length) {
    await backupStore.bulkDelete(selectedSystemIds.value);
    selectedSystemIds.value = [];
  } else if (type === "database" && selectedDbIds.value.length) {
    await backupStore.bulkDelete(selectedDbIds.value);
    selectedDbIds.value = [];
  }
}

function prepareDelete(item, type) {
  // For single-row delete via modal:
  backupStore.setPendingDelete([item.id], type);
}

onMounted(() => {
  backupStore.fetchAll();
});
</script>


